/**
 * 按语言懒加载主语言包 + help-qa + tutorial-qa，避免打包时一次性打入全部语言。
 */
function mergeLocaleChunks(base, helpQa, tutorialQa) {
  return {
    ...base,
    help: {
      ...(base.help || {}),
      ...(helpQa.help || {}),
    },
    tutorial: {
      ...(base.tutorial || {}),
      ...(tutorialQa.tutorial || {}),
    },
  };
}

const localeLoaders = {
  zh: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-zh" */ "@/locales/zh.json"),
      import(/* webpackChunkName: "help-qa-zh" */ "@/locales/help-qa/zh.json"),
      import(/* webpackChunkName: "tutorial-qa-zh" */ "@/locales/tutorial-qa/zh.json"),
    ]),
  hk: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-hk" */ "@/locales/hk.json"),
      import(/* webpackChunkName: "help-qa-hk" */ "@/locales/help-qa/hk.json"),
      import(/* webpackChunkName: "tutorial-qa-hk" */ "@/locales/tutorial-qa/hk.json"),
    ]),
  en: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-en" */ "@/locales/en.json"),
      import(/* webpackChunkName: "help-qa-en" */ "@/locales/help-qa/en.json"),
      import(/* webpackChunkName: "tutorial-qa-en" */ "@/locales/tutorial-qa/en.json"),
    ]),
  th: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-th" */ "@/locales/th.json"),
      import(/* webpackChunkName: "help-qa-th" */ "@/locales/help-qa/th.json"),
      import(/* webpackChunkName: "tutorial-qa-th" */ "@/locales/tutorial-qa/th.json"),
    ]),
  vn: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-vn" */ "@/locales/vn.json"),
      import(/* webpackChunkName: "help-qa-vn" */ "@/locales/help-qa/vn.json"),
      import(/* webpackChunkName: "tutorial-qa-vn" */ "@/locales/tutorial-qa/vn.json"),
    ]),
  pg: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-pg" */ "@/locales/pg.json"),
      import(/* webpackChunkName: "help-qa-pg" */ "@/locales/help-qa/pg.json"),
      import(/* webpackChunkName: "tutorial-qa-pg" */ "@/locales/tutorial-qa/pg.json"),
    ]),
  fp: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-fp" */ "@/locales/fp.json"),
      import(/* webpackChunkName: "help-qa-fp" */ "@/locales/help-qa/fp.json"),
      import(/* webpackChunkName: "tutorial-qa-fp" */ "@/locales/tutorial-qa/fp.json"),
    ]),
  md: () =>
    Promise.all([
      import(/* webpackChunkName: "locale-md" */ "@/locales/md.json"),
      import(/* webpackChunkName: "help-qa-md" */ "@/locales/help-qa/md.json"),
      import(/* webpackChunkName: "tutorial-qa-md" */ "@/locales/tutorial-qa/md.json"),
    ]),
};

const loadedLocales = new Set();

export async function loadLocaleMessages(locale, i18n) {
  if (loadedLocales.has(locale)) return;
  const loader = localeLoaders[locale];
  if (!loader) return;
  const [baseMod, helpMod, tutorialMod] = await loader();
  const base = baseMod.default || baseMod;
  const helpQa = helpMod.default || helpMod;
  const tutorialQa = tutorialMod.default || tutorialMod;
  i18n.setLocaleMessage(locale, mergeLocaleChunks(base, helpQa, tutorialQa));
  loadedLocales.add(locale);
}

export function markLocaleLoaded(locale) {
  loadedLocales.add(locale);
}
